export default "__VITE_ASSET__ByLlg7Cv__"